module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('ResourcesCapacity')
      }
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex align-items-center mb-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n          Total Capacity\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.maximumLotation),
      expression: "getSelectedEvent.maximumLotation"
    }],
    staticClass: "bg-lighter mt-1",
    attrs: {
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.maximumLotation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "maximumLotation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('checkbox', {
    staticClass: "ml-3 mt-3",
    attrs: {
      "name": "allotment"
    },
    model: {
      value: (_vm.hasAllotments),
      callback: function($$v) {
        _vm.hasAllotments = $$v
      },
      expression: "hasAllotments"
    }
  }, [_vm._v("Set Allotment")])], 1)]), _vm._v(" "), (_vm.hasAllotments) ? _c('div', {
    staticClass: "row pt-4 border-top-light"
  }, [_vm._l((this.getSelectedEvent.eventAlotments), function(allotment, index) {
    return _c('div', {
      staticClass: "w-100 d-flex mb-3 align-items-center"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v("\n                      Allotment\n                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (allotment.quantityAlotment),
        expression: "allotment.quantityAlotment"
      }],
      staticClass: "bg-lighter",
      attrs: {
        "type": "number",
        "size": "10"
      },
      domProps: {
        "value": (allotment.quantityAlotment)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(allotment, "quantityAlotment", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v("\n                      Linked To\n                  ")]), _vm._v(" "), _c('v-select', {
      attrs: {
        "options": _vm.allotedToOptions
      },
      on: {
        "input": function($event) {
          return _vm.allotmentLinkedToChanged(allotment)
        }
      },
      model: {
        value: (allotment.linkedTo),
        callback: function($$v) {
          _vm.$set(allotment, "linkedTo", $$v)
        },
        expression: "allotment.linkedTo"
      }
    })], 1), _vm._v(" "), (allotment.linkedTo.value == 'agent') ? _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v("\n                      Name\n                  ")]), _vm._v(" "), _c('v-select', {
      attrs: {
        "options": _vm.availableAgents,
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.allotmentNameChanged(allotment.agent, _vm.availableAgents, allotment)
        }
      },
      model: {
        value: (allotment.agent),
        callback: function($$v) {
          _vm.$set(allotment, "agent", $$v)
        },
        expression: "allotment.agent"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete largest dark pointer mt-3",
      on: {
        "click": function($event) {
          return _vm.removeAllotment(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3 mb-4"
  }, [_c('span', {
    on: {
      "click": _vm.addAllotment
    }
  }, [_c('span', {
    staticClass: "ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer"
  }, [_vm._v("Add New")])])])], 2) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3e0b4bca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0b4bca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaCapacity.vue
// module id = 1365
// module chunks = 0